import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { useAuth } from '../contexts/AuthContext';

// importa o SVG como componente (CRA/SVGR)
import { ReactComponent as Logo } from '../assets/logo.svg';
import { APP_VERSION } from '../version';

export default function TopBar({ onMenuClick }) {
  const { logout } = useAuth();

  return (
    <AppBar
      position="fixed"
      elevation={1}
      sx={{ zIndex: (t) => t.zIndex.drawer + 1 }}
    >
      <Toolbar>
        {/* Hambúrguer: visível apenas em telas < md */}
        <IconButton
          color="inherit"
          edge="start"
          aria-label="menu"
          onClick={onMenuClick}
          sx={{ mr: 2, display: { xs: 'inline-flex', md: 'none' } }}
        >
          <MenuIcon />
        </IconButton>

        {/* Logo e Versão */}
        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
          <Logo style={{ height: 70, width: 'auto', display: 'block', color: '#fff' }} />
          <Typography
            variant="caption"
            sx={{
              ml: 1.5,
              px: 1,
              py: 0.2,
              borderRadius: 1,
              bgcolor: 'rgba(255, 255, 255, 0.18)',
              color: '#fff',
              fontWeight: 700,
              letterSpacing: 0.5,
              fontSize: '0.75rem',
              border: '1px solid rgba(255,255,255,0.3)',
            }}
          >
            v{APP_VERSION}
          </Typography>
        </Box>

        <Button color="inherit" onClick={logout}>Sair</Button>
      </Toolbar>
    </AppBar>
  );
}
